import React from 'react';
import react from '../../assets/images/react-icon.svg';
import nodejs from '../../assets/images/nodejs-icon.svg';
import express from '../../assets/images/express-icon.png';
import mongodb from '../../assets/images/mongodb-icon.svg';

const SkillsContent = () => {
    return (
        <div className='dark:text-white'>
            <div className=" p-6 box-border rounded-xl" 
            >
                <div className="">
                    <ul className="flex flex-col space-y-1">
                        <div className="flex items-center space-x-3">
                            <img src={react} alt="85%" className="w-10 object-contain"/>
                            <div className="w-full bg-slate-300 dark:bg-gray-200 h-[6px] rounded-xl overflow-hidden">
                                <div className="bg-[#61dafb] bg-opacity-90 h-[6px] leading-loose py-[3px] text-right dark:text-white rounded-xl text-sm" style={{width: "85%"}} 
                                data-aos="fade-right" data-aos-easing="linear" data-aos-duration="2000">
                                    85%
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center space-x-3">
                            <img src={nodejs} alt="60%" className="w-10 object-contain"/>
                            <div className="w-full bg-slate-300 dark:bg-gray-200 h-[6px] rounded-xl overflow-hidden">
                                <div className="bg-[#8cc84b] bg-opacity-90 h-[6px] leading-loose py-[3px] text-right dark:text-white rounded-xl text-sm " style={{width: "60%"}}
                                data-aos="fade-right" data-aos-easing="linear" data-aos-duration="2000">
                                    60%
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center space-x-3">
                            <img src={express} alt="70%" className="w-10 object-contain"/>
                            <div className="w-full bg-slate-300 dark:bg-gray-200 h-[6px] rounded-xl overflow-hidden">
                                <div className="bg-[#ffd15c] bg-opacity-90 h-[6px] leading-loose py-[3px] text-right dark:text-white rounded-xl text-sm overflow-visible" style={{width: "70%"}}
                                data-aos="fade-right" data-aos-easing="linear" data-aos-duration="2000">
                                    70%
                                </div>
                            </div>
                        </div>
                        <div className="flex items-center space-x-3">
                            <img src={mongodb} alt="65%" className="w-10 object-contain"/>
                            <div className="w-full bg-slate-300 dark:bg-gray-200 h-[6px] rounded-xl overflow-hidden">
                                <div className="bg-[#3C873A] bg-opacity-90 h-[6px] leading-loose py-[3px] text-right dark:text-white rounded-xl text-sm" style={{width: "65%"}}
                                data-aos="fade-right" data-aos-easing="linear" data-aos-duration="2000">
                                    65%
                                </div>
                            </div>
                        </div>
                    </ul>
                </div>

                <h1 className='my-5'><span>Other skills</span></h1>

                <div className="">
                    <ul className="flex flex-wrap items-center space-x-6">
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/html-1.svg" alt="90%" className="w-8 object-contain"/>
                        </div>
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/css-3.svg" alt="80%" className="w-8 object-contain"/>
                        </div>
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/logo-javascript.svg" alt="75%" className="w-8 object-contain"/>
                        </div>
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/tailwindcss.svg" alt="95%" className="w-8 object-contain"/>
                        </div>
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/bootstrap-5-1.svg" alt="85%" className="w-8 object-contain"/>
                        </div>
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/react-1.svg" alt="88%" className="w-8 object-contain"/>
                        </div>
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/material-ui-1.svg" alt="60%" className="w-8 object-contain"/>
                        </div>
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/sass-1.svg" alt="75%" className="w-8 object-contain"/>
                        </div>
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/git-bash.svg" alt="90%" className="w-8 object-contain"/>
                        </div>
                        <div className="flex flex-col space-x-3">
                            <img src="https://cdn.worldvectorlogo.com/logos/firebase-2.svg" alt="90%" className="w-6 object-contain"/>
                        </div>
                    </ul>
                    
                </div>
            </div>
        </div> 
    );
};

export default SkillsContent;